export default {
  name: 'lo',
  el: {
    breadcrumb: {
      label: 'ເມນູນຳທາງ',
    },
    colorpicker: {
      confirm: 'ຕົກລົງ',
      clear: 'ລ້າງ',
      defaultLabel: 'ເຄື່ອງມືເລືອກສີ',
      description: 'ສີປັດຈຸບັນແມ່ນ {color}. ກົດ enter ເພື່ອເລືອກສີໃໝ່.',
      alphaLabel: 'ເລືອກຄ່າຄວາມໂປ່ງໃສ',
      alphaDescription: 'alpha {alpha}, current color is {color}', // to be translated
      hueLabel: 'pick hue value', // to be translated
      hueDescription: 'hue {hue}, current color is {color}', // to be translated
      svLabel: 'pick saturation and brightness value', // to be translated
      svDescription:
        'saturation {saturation}, brightness {brightness}, current color is {color}', // to be translated
      predefineDescription: 'select {value} as the color', // to be translated
    },
    datepicker: {
      now: 'ຕອນນີ້',
      today: 'ມື້ນີ້',
      cancel: 'ຍົກເລີກ',
      clear: 'ລ້າງ',
      confirm: 'ຕົກລົງ',
      dateTablePrompt: 'ໃຊ້ປຸ່ມລູກສອນ ແລະ ປຸ່ມ enter ເພື່ອເລືອກວັນທີຂອງເດືອນ',
      monthTablePrompt: 'ໃຊ້ປຸ່ມລູກສອນ ແລະ ປຸ່ມ enter ເພື່ອເລືອກເດືອນ',
      yearTablePrompt: 'ໃຊ້ປຸ່ມລູກສອນ ແລະ ປຸ່ມ enter ເພື່ອເລືອກປີ',
      selectedDate: 'ວັນທີທີ່ເລືອກ',
      selectDate: 'ເລືອກວັນທີ',
      selectTime: 'ເລືອກເວລາ',
      startDate: 'ວັນທີເລີ່ມຕົ້ນ',
      startTime: 'ເວລາເລີ່ມຕົ້ນ',
      endDate: 'ວັນທີສິ້ນສຸດ',
      endTime: 'ເວລາສິ້ນສຸດ',
      prevYear: 'ປີກ່ອນໜ້າ',
      nextYear: 'ປີຖັດໄປ',
      prevMonth: 'ເດືອນກ່ອນໜ້າ',
      nextMonth: 'ເດືອນຖັດໄປ',
      year: 'ປີ',
      month1: 'ມັງກອນ',
      month2: 'ກຸມພາ',
      month3: 'ມີນາ',
      month4: 'ເມສາ',
      month5: 'ພຶດສະພາ',
      month6: 'ມິຖຸນາ',
      month7: 'ກໍລະກົດ',
      month8: 'ສິງຫາ',
      month9: 'ກັນຍາ',
      month10: 'ຕຸລາ',
      month11: 'ພະຈິກ',
      month12: 'ທັນວາ',
      weeks: {
        sun: 'ອາ',
        mon: 'ຈ',
        tue: 'ອ',
        wed: 'ພ',
        thu: 'ພຫ',
        fri: 'ສ',
        sat: 'ເສົາ',
      },
      weeksFull: {
        sun: 'ອາທິດ',
        mon: 'ຈັນ',
        tue: 'ອັງຄານ',
        wed: 'ພຸດ',
        thu: 'ພະຫັດ',
        fri: 'ສຸກ',
        sat: 'ເສົາ',
      },
      months: {
        jan: 'ມັງກອນ',
        feb: 'ກຸມພາ',
        mar: 'ມີນາ',
        apr: 'ເມສາ',
        may: 'ພຶດສະພາ',
        jun: 'ມິຖຸນາ',
        jul: 'ກໍລະກົດ',
        aug: 'ສິງຫາ',
        sep: 'ກັນຍາ',
        oct: 'ຕຸລາ',
        nov: 'ພະຈິກ',
        dec: 'ທັນວາ',
      },
    },
    inputNumber: {
      decrease: 'ຫຼຸດຈຳນວນ',
      increase: 'ເພີ່ມຈຳນວນ',
    },
    select: {
      loading: 'ກຳລັງໂຫຼດ',
      noMatch: 'ບໍ່ພົບຂໍ້ມູນທີ່ກົງກັນ',
      noData: 'ບໍ່ມີຂໍ້ມູນ',
      placeholder: 'ເລືອກ',
    },
    mention: {
      loading: 'ກຳລັງໂຫຼດ',
    },
    dropdown: {
      toggleDropdown: 'ສະຫຼັບເມນູ',
    },
    cascader: {
      noMatch: 'ບໍ່ພົບຂໍ້ມູນທີ່ກົງກັນ',
      loading: 'ກຳລັງໂຫຼດ',
      placeholder: 'ເລືອກ',
      noData: 'ບໍ່ມີຂໍ້ມູນ',
    },
    pagination: {
      goto: 'ໄປທີ່',
      pagesize: '/ໜ້າ',
      total: 'ທັງໝົດ {total}',
      pageClassifier: '',
      page: 'ໜ້າ',
      prev: 'ຍ້ອນກັບ',
      next: 'ຖັດໄປ',
      currentPage: 'ໜ້າ {pager}',
      prevPages: 'ຍ້ອນກັບ {pager} ໜ້າ',
      nextPages: 'ຖັດໄປ {pager} ໜ້າ',
      deprecationWarning:
        'ພົບການໃຊ້ງານທີ່ບໍ່ຖືກຕ້ອງ, ກະລຸນາເບິ່ງເອກະສານການໃຊ້ງານ el-pagination ສຳລັບລາຍລະອຽດເພີ່ມເຕີມ',
    },
    dialog: {
      close: 'ປິດກ່ອງຂໍ້ຄວາມນີ້',
    },
    drawer: {
      close: 'ປິດກ່ອງຂໍ້ຄວາມນີ້',
    },
    messagebox: {
      title: 'ຂໍ້ຄວາມ',
      confirm: 'ຕົກລົງ',
      cancel: 'ຍົກເລີກ',
      error: 'ຂໍ້ມູນບໍ່ຖືກຕ້ອງ',
      close: 'ປິດກ່ອງຂໍ້ຄວາມນີ້',
    },
    upload: {
      deleteTip: 'ກົດປຸ່ມລົບເພື່ອລົບອອກ',
      delete: 'ລົບ',
      preview: 'ເບິ່ງຕົວຢ່າງ',
      continue: 'ສືບຕໍ່',
    },
    slider: {
      defaultLabel: 'ສະໄລເດີລະຫວ່າງ {min} ແລະ {max}',
      defaultRangeStartLabel: 'ເລືອກຄ່າເລີ່ມຕົ້ນ',
      defaultRangeEndLabel: 'ເລືອກຄ່າສິ້ນສຸດ',
    },
    table: {
      emptyText: 'ບໍ່ມີຂໍ້ມູນ',
      confirmFilter: 'ຢືນຢັນ',
      resetFilter: 'ຄືນຄ່າໃໝ່',
      clearFilter: 'ທັງໝົດ',
      sumText: 'ຜົນລວມ',
      selectAllLabel: 'Select all rows', // to be translated
      selectRowLabel: 'Select this row', // to be translated
      expandRowLabel: 'Expand this row', // to be translated
      collapseRowLabel: 'Collapse this row', // to be translated
      sortLabel: 'Sort by {column}', // to be translated
      filterLabel: 'Filter by {column}', // to be translated
    },
    tag: {
      close: 'Close this tag', // to be translated
    },
    tour: {
      next: 'ຖັດໄປ',
      previous: 'ຍ້ອນກັບ',
      finish: 'ສຳເລັດ',
      close: 'Close this dialog', // to be translated
    },
    tree: {
      emptyText: 'ບໍ່ມີຂໍ້ມູນ',
    },
    transfer: {
      noMatch: 'ບໍ່ພົບຂໍ້ມູນທີ່ກົງກັນ',
      noData: 'ບໍ່ມີຂໍ້ມູນ',
      titles: ['ລາຍການທີ 1', 'ລາຍການທີ 2'],
      filterPlaceholder: 'ປ້ອນຄຳຄົ້ນຫາ',
      noCheckedFormat: '{total} ລາຍການ',
      hasCheckedFormat: '{checked}/{total} ເລືອກແລ້ວ',
    },
    image: {
      error: 'ເກີດຂໍ້ຜິດພາດ',
    },
    pageHeader: {
      title: 'ກັບຄືນ',
    },
    popconfirm: {
      confirmButtonText: 'ຕົກລົງ',
      cancelButtonText: 'ຍົກເລີກ',
    },
    carousel: {
      leftArrow: 'ລູກສອນເບື້ອງຊ້າຍຂອງ Carousel',
      rightArrow: 'ລູກສອນເບື້ອງຂວາຂອງ Carousel',
      indicator: 'Carousel ສະຫຼັບໄປລຳດັບທີ {index}',
    },
    inputOTP: {
      groupLabel: 'OTP Input', // to be translated
      defaultLabel: 'Please enter OTP character {index}', // to be translated
    },
  },
}
